import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    getCounts
} from './api'
import { getDashboardCount, InitialState } from './types'

const initialState: InitialState = {
    getCount: {
        batchCount: '',
        studentCount: '',
        teacherCount: '',
        branchCount: '',
        testCount: ''
    },
    isLoading: false
}

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: {
        [getCounts.pending.toString()]: (state) => {
            state.isLoading = true
        },
        [getCounts.fulfilled.toString()]: (state, action: PayloadAction<getDashboardCount>) => {
            state.isLoading = false
            state.getCount = action?.payload
        },
        [getCounts.rejected.toString()]: (state) => {
            state.isLoading = false
        },
    }
})

export default dashboardSlice.reducer
